import styled from '@emotion/styled';
import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';
import { Grid } from '@naf/grid';
import { breakpoints, spacing } from '@naf/theme';
import { Text } from '@naf/text';
import { MapWrapper } from '@loadable-elements/LoadableGoogleMapsAPI';
import BreadCrumb from '../../../../components/breadcrumb/BreadCrumb';

export const StyledGrid = styled(Grid)`
  row-gap: 0;
`;

export const Header = styled(Text)`
  grid-column: 3 / 10;

  @media (max-width: ${breakpoints.l}) {
    grid-column: 1 / 13;
    margin: ${spacing.space24} 0;
  }
`;

export const Ingress = styled(Text)`
  grid-column: 3 / 10;
  margin-top: 0;
  margin-bottom: ${spacing.space64};

  @media (max-width: ${breakpoints.l}) {
    grid-column: 1 / 13;
    margin-bottom: ${spacing.space40};
  }
`;

export const StyledBreadcrumb = styled(BreadCrumb)`
  grid-column: 3 / 10;

  @media (max-width: ${breakpoints.s}) {
    grid-column: 1 / 13;
  }
`;

export const Map = styled.div`
  grid-column: 1 / 13;
  width: 100%;

  @media (max-width: ${breakpoints.s}) {
    grid-column: 1 / 13;
    margin-left: -${spacing.space24};
    margin-right: -${spacing.space24};
    width: 100vw;
  }
`;

export const Body = styled.div`
  grid-column: 4 / 10;
  margin-top: ${spacing.space64};
  max-width: 700px;
  width: 100%;
  align-self: center;

  & h2,
  & h3 {
    margin-top: 0;
  }

  @media (max-width: ${breakpoints.l}) {
    grid-column: 1 / 9;
  }

  @media (max-width: ${breakpoints.m}) {
    grid-row: 5;
    grid-column: 1 / 13;
    max-width: 100%;
    margin-top: ${spacing.space32};
  }
`;

export const Contact = styled.div`
  grid-column: 10 / 13;
  margin-top: ${spacing.space40};
  display: flex;
  flex-direction: column;
  gap: ${spacing.space16};
  align-items: flex-start;
  word-break: break-word;
  min-width: 220px;
  max-width: 350px;

  & > * {
    width: 100%;
  }

  @media (max-width: ${breakpoints.m}) {
    margin-top: ${spacing.space16};
    grid-column: 1 / 13;
    grid-row: 4;
    flex-direction: column;
    align-items: stretch;
    max-width: 100%;
    min-width: 0;
  }
`;

export const Mapbutton = simbaStyled(Button)(({ theme }) => ({
  '&&': {
    position: 'absolute',
    bottom: theme.spacing(8),
    right: theme.spacing(10),
    '& > span': {
      display: 'flex',
      gap: theme.spacing(3),
    },
  },
}));

export const ContactHeader = styled(Text)`
  margin-top: ${spacing.space24};
  margin-bottom: ${spacing.space8};
`;

export const NoMarginText = styled(Text)`
  margin: 0;
`;

export const StyledMapWrapper = styled(MapWrapper)`
  width: 100%;
  height: 524px;

  @media (max-width: ${breakpoints.s}) {
    height: 90vh;
  }
`;
